import {environment} from "../../../../../environments/environment";
import {HttpHeaders} from "@angular/common/http";


// const UAT_URL = 'https://10.71.33.215/ppm-uat/';
const UAT_URL = '';

const requestOptionsHeader = new HttpHeaders()
  .set('Content-Type', 'application/vnd.pension.v1+json;charset=UTF-8')
  .set('Accept', 'application/vnd.pension.v1+json;charset=UTF-8')
  .set('appid', 'epension');

const requestOptionsHeaderForDownload = function(filename, extension) {
  return new HttpHeaders()
    .set('Content-Type', 'application/octet-stream')
    .set('Content-Disposition', 'attachment; filename="' + filename + '.' + extension + '"')
};

const requestOptionsHeaderForLogin = new HttpHeaders()
  .set('Content-Type', 'application/x-www-form-urlencoded')
  .set('Accept', 'application/vnd.pmi.v1+json;charset=UTF-8')
  .set('appid', 'epension');

const requestOptionsHeaderForJson = new HttpHeaders()
  .set('Content-Type', 'application/json;charset=UTF-8')
  .set('Accept', 'application/json;charset=UTF-8')
  .set('appid', 'epension');

export const ApiConfig = {
  baseURL: (environment.env_name == 'DEV') ? UAT_URL : '',
  requestOptionsHeader: requestOptionsHeader,
  requestOptionsHeaderForDownload: requestOptionsHeaderForDownload,
  requestOptionsHeaderForLogin: requestOptionsHeaderForLogin,
  requestOptionsHeaderForJson: requestOptionsHeaderForJson
};
